module.exports = __webpack_public_path__ + "img/blog-59.7d42b039.jpg";